import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configuration from config file

/**
 * Class representing the table landing report view.
 * @extends JetView
 */
export default class tableLandingReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the DataTable
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                // Column definitions
                                {
                                    id: 'Id', // Column ID
                                    header: _('Id'), // Column header with localization
                                    width: 80, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Template', // Column ID
                                    header: _('Plantilla'), // Column header with localization
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Partner', // Column ID
                                    header: _('Partner'), // Column header with localization
                                    width: 250, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'IsActivate', // Column ID
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activado') }, // Activated option
                                        { id: 'I', value: _('Inactivado') }, // Inactivated option
                                    ],
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                ,
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    // Edit event
                                    var item = this.getItem(id); // Get the clicked item
                                    $$('editwinPartnerProducts').show(); // Show the edit window
                                    var record = $$('editform').getValues(); // Get values from the edit form
                                    $$('formPartnersEdit').setValue(record.Partners); // Set partners in the form
                                    vthis.app.callEvent('changePartnetsEdit', [{}]); // Trigger event for partner edit change
                                    $$('formCategoriesEdit').setValue(record.CategoriesAdd); // Set categories in the form
                                    vthis.app.callEvent('changeCategoriesEdit', [{}]); // Trigger event for category edit change
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            // Data source URL
                            url: devConfig.geturlApi() + 'es/LandingPages/GetLandings',
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event handlers.
     * @param {Object} grid - The grid component.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the DataTable
        var url = grid.data.url; // Data source URL
        var products = []; // Array to hold products
        var filter = ''; // Filter string
        var optionsCategorias = []; // Array for category options
        var vthis = this; // Reference to the current instance
        var popup = ''; // Variable for the edit popup
        var popupAdd = ''; // Variable for the add popup
        var arrayPartnersAdd = []; // Array for added partners
        var arrayPartnersWithoutAdd = []; // Array for partners not added
        var arrayPartnersEdit = []; // Array for edited partners
        var arrayPartnersWithoutEdit = []; // Array for partners not edited
        var arrayAdd = []; // Array for added categories
        var arrayWithoutAdd = []; // Array for categories not added
        var arrayAddEdit = []; // Array for edited categories
        var arrayWithoutAddEdit = []; // Array for categories not edited

        // AJAX request to fetch categories
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Categories/GetCategories', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handler
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handler
                    var resp = JSON.parse(text); // Parse response
                    for (var i = 0; i < resp.data.length; i++) {
                        // Loop through response data
                        resp.data[i].id = resp.data[i].Id; // Map Id to id
                        resp.data[i].value = resp.data[i].Description; // Map Description to value
                    }
                    optionsCategorias = resp.data; // Set category options
                    popup = webix.ui({
                        // Create edit popup
                        view: 'window',
                        id: 'editwinPartnerProducts', // ID for the edit window
                        width: screen.width < 500 ? 500 : 650, // Set width based on screen size
                        height: screen.width < 500 ? 1100 : 700, // Set height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                        head: {
                            // Header configuration
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Editar Productos Partner'), // Label for the header
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        // Click event for closing the popup
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center position
                        modal: false, // Non-modal window
                        body: {
                            // Body configuration
                            view: 'scrollview', // Scrollable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            body: {
                                view: 'form', // Form component
                                id: 'editform', // ID for the edit form
                                width: screen.width < 500 ? 500 : 650, // Set width based on screen size
                                height: screen.width < 500 ? 1100 : 1100, // Set height based on screen size
                                elements: [
                                    // Form elements
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: 'Id', // Label text
                                                name: 'Id', // Input name
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Tiempo Procesamiento'), // Label with localization
                                                name: 'ProcessingTime', // Input name
                                                labelWidth: 160, // Label width
                                                readonly: true, // Read-only input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Productos'), // Label with localization
                                                name: 'Product', // Input name
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Proveedor'), // Label with localization
                                                name: 'ProviderId', // Input name
                                                readonly: true, // Read-only input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Estado'), // Label with localization
                                                name: 'IsActivate', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Verificado'), // Label with localization
                                                name: 'IsVerified', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Filtro País'), // Label with localization
                                                name: 'FilterCountry', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Mobile'), // Label with localization
                                                name: 'Mobile', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'S',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'N',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                                readonly: true, // Read-only input
                                            },
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Escritorio'), // Label with localization
                                                name: 'Desktop', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'S',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'N',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                                readonly: true, // Read-only input
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Máximo'), // Label with localization
                                                name: 'Maximum', // Input name
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Mínimo'), // Label with localization
                                                name: 'Minimum', // Input name
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Orden'), // Label with localization
                                                name: 'Order', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Orden Destacado'), // Label with localization
                                                name: 'FeaturedOrder', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Filas'), // Label with localization
                                                name: 'Rows', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Columnas'), // Label with localization
                                                name: 'Columns', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        view: 'forminput', // Double list input for partners
                                        id: 'formPartnersEdit', // ID for the partners edit form
                                        body: {
                                            view: 'dbllist', // Double list component
                                            id: 'dblPartnersEdit', // ID for the double list
                                            list: { height: 200, scroll: true }, // List configuration
                                            labelLeft: _('Partners no Seleccionados'), // Left label
                                            labelRight: _('Partners Seleccionados'), // Right label
                                            data: profile.Partners, // Data source for partners
                                        },
                                        labelWidth: 140, // Label width
                                        labelAlign: 'right', // Label alignment
                                    },
                                    {
                                        view: 'forminput', // Double list input for categories
                                        id: 'formCategoriesEdit', // ID for the categories edit form
                                        body: {
                                            view: 'dbllist', // Double list component
                                            id: 'dbllistEdit', // ID for the double list
                                            list: { height: 200, scroll: true }, // List configuration
                                            labelLeft: _('Categorías sin agregar'), // Left label
                                            labelRight: _('Categorías Producto Partner'), // Right label
                                            data: optionsCategorias, // Data source for categories
                                        },
                                        labelWidth: 140, // Label width
                                        labelAlign: 'right', // Label alignment
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Explicación'), // Label with localization
                                                name: 'Reason', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'text' }, // Input type
                                            },
                                        ],
                                    },
                                    { gravity: 1 }, // Flexible space
                                    {
                                        cols: [
                                            // Column layout for buttons
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'), // Button text with localization
                                                click: function () {
                                                    // Click event for cancel button
                                                    this.getTopParentView().hide(); // Hide the popup
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form', // Button type
                                                value: _('Guardar'), // Button text with localization
                                                click: function ($e) {
                                                    // Click event for save button
                                                    var values = $$(
                                                        // Get values from the form
                                                        'editform',
                                                    ).getValues();
                                                    values.Partners = arrayPartnersEdit; // Set partners
                                                    arrayPartnersWithoutEdit = []; // Reset array for partners not edited
                                                    for (
                                                        // Loop through profile partners
                                                        var i = 0;
                                                        i < profile.Partners.length;
                                                        i++
                                                    ) {
                                                        var flagPartners = false; // Flag for partner existence
                                                        for (
                                                            // Check if partner is in edited array
                                                            var j = 0;
                                                            (j < arrayPartnersEdit.length) & !flagPartners;
                                                            j++
                                                        ) {
                                                            if (profile.Partners[i].id == arrayPartnersEdit[j])
                                                                flagPartners = true; // Set flag if found
                                                        }
                                                        if (!flagPartners)
                                                            // If not found, add to the array
                                                            arrayPartnersWithoutEdit.push(profile.Partners[i].id);
                                                    }
                                                    values.PartnersWithoutAdd = arrayPartnersWithoutEdit; // Set partners not added
                                                    values.CategoriesAdd = arrayAddEdit; // Set categories added
                                                    arrayWithoutAddEdit = []; // Reset array for categories not added
                                                    for (
                                                        // Loop through category options
                                                        var i = 0;
                                                        i < optionsCategorias.length;
                                                        i++
                                                    ) {
                                                        var flag = false; // Flag for category existence
                                                        for (
                                                            // Check if category is in added array
                                                            var j = 0;
                                                            (j < arrayAddEdit.length) & !flag;
                                                            j++
                                                        ) {
                                                            if (optionsCategorias[i].Id == arrayAddEdit[j]) flag = true; // Set flag if found
                                                        }
                                                        if (!flag)
                                                            // If not found, add to the array
                                                            arrayWithoutAddEdit.push(optionsCategorias[i].Id);
                                                    }
                                                    values.CategoriesWithoutAdd = arrayWithoutAddEdit; // Set categories not added
                                                    // AJAX request to update partner product details
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                                'PartnerProduct/UpdatePartnerProductDetails',
                                                            '{"Id":' +
                                                                values.Id +
                                                                ',"IsActivate":"' +
                                                                values.IsActivate +
                                                                '","IsVerified":"' +
                                                                values.IsVerified +
                                                                '","FilterCountry":"' +
                                                                values.FilterCountry +
                                                                '", "Maximum":"' +
                                                                values.Maximum +
                                                                '", "Minimum":"' +
                                                                values.Minimum +
                                                                '", "Order":"' +
                                                                values.Order +
                                                                '", "FeaturedOrder":"' +
                                                                values.FeaturedOrder +
                                                                '", "Rows":"' +
                                                                values.Rows +
                                                                '", "Columns":"' +
                                                                values.Columns +
                                                                '", "Reason":"' +
                                                                values.Reason +
                                                                '", "Partners":"' +
                                                                values.Partners +
                                                                '", "PartnersWithoutAdd":"' +
                                                                values.PartnersWithoutAdd +
                                                                '", "CategoriesAdd":"' +
                                                                values.CategoriesAdd +
                                                                '", "CategoriesWithoutAdd":"' +
                                                                values.CategoriesWithoutAdd +
                                                                '"}',
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message('Error! '); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    webix.message('Producto Partner Editado'); // Show success message
                                                                    grid.clearAll(); // Clear the grid
                                                                    grid.load(
                                                                        // Reload the grid data
                                                                        url +
                                                                            '?start=0&count=' +
                                                                            grid.data.$pagesize +
                                                                            filter,
                                                                    );
                                                                },
                                                            },
                                                        );
                                                    this.getTopParentView().hide(); // Hide the popup
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    $$('editform').bind($$('datatable')); // Bind the edit form to the DataTable
                    $$('dblPartnersEdit').attachEvent(
                        // Attach event for partner edit double list
                        'onChange',
                        function (id, e, node) {
                            vthis.app.callEvent('changePartnetsEdit', [{}]); // Trigger event for partner edit change
                        },
                    );
                    $$('dbllistEdit').attachEvent(
                        // Attach event for category edit double list
                        'onChange',
                        function (id, e, node) {
                            vthis.app.callEvent('changeCategoriesEdit', [{}]); // Trigger event for category edit change
                        },
                    );
                    popupAdd = webix.ui({
                        // Create add popup
                        view: 'window',
                        id: 'AddPartnerProducts', // ID for the add window
                        width: screen.width < 500 ? 500 : 600, // Set width based on screen size
                        height: screen.width < 500 ? 1000 : 700, // Set height based on screen size
                        fullscreen: screen.width < 500 ? true : false, // Fullscreen mode based on screen size
                        head: {
                            // Header configuration
                            view: 'toolbar',
                            cols: [
                                {
                                    view: 'label',
                                    label: _('Añadir Producto Partner'), // Label for the header
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    click: function () {
                                        // Click event for closing the popup
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                        position: 'center', // Center position
                        modal: true, // Modal window
                        body: {
                            // Body configuration
                            view: 'scrollview', // Scrollable view
                            scroll: 'xy', // Enable both horizontal and vertical scrolling
                            body: {
                                view: 'form', // Form component
                                id: 'addform', // ID for the add form
                                width: screen.width < 500 ? 500 : 600, // Set width based on screen size
                                height: screen.width < 500 ? 900 : 900, // Set height based on screen size
                                elements: [
                                    // Form elements
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: 'Productos', // Label text
                                                name: 'Product', // Input name
                                                options: {
                                                    // Options for the combo
                                                    body: {
                                                        dataFeed: function (text) {
                                                            // Data feed function
                                                            var vthis = this; // Reference to the current instance
                                                            if (text.length > 2) {
                                                                // Check input length
                                                                webix
                                                                    .ajax()
                                                                    .headers({
                                                                        'Content-type': 'application/json', // Set content type
                                                                    })
                                                                    .post(
                                                                        devConfig.geturlApi() +
                                                                            'es/Select/GamesCasinoSelect',
                                                                        '{"Filter":"' + text + '"}',
                                                                        {
                                                                            error: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Error handler
                                                                                webix.message('Error! '); // Show error message
                                                                            },
                                                                            success: function (
                                                                                text,
                                                                                data,
                                                                                XmlHttpRequest,
                                                                            ) {
                                                                                // Success handler
                                                                                var resp = JSON.parse(text); // Parse response
                                                                                if (!resp.HasError) {
                                                                                    // Check for errors
                                                                                    vthis.parse(resp.Data); // Parse data into the combo
                                                                                }
                                                                            },
                                                                        },
                                                                    );
                                                            }
                                                        },
                                                    },
                                                },
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Estado'), // Label with localization
                                                name: 'IsActivate', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Verificado'), // Label with localization
                                                name: 'IsVerified', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'combo', // Combo input
                                                labelPosition: 'top', // Label position
                                                label: _('Filtro País'), // Label with localization
                                                name: 'FilterCountry', // Input name
                                                options: [
                                                    // Options for the combo
                                                    {
                                                        id: 'A',
                                                        value: _('Activado'), // Activated option
                                                    },
                                                    {
                                                        id: 'I',
                                                        value: _('Inactivado'), // Inactivated option
                                                    },
                                                ],
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Tiempo Procesamiento'), // Label with localization
                                                name: 'ProcessingTime', // Input name
                                                labelWidth: 160, // Label width
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Máximo'), // Label with localization
                                                name: 'Maximum', // Input name
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Mínimo'), // Label with localization
                                                name: 'Minimum', // Input name
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        margin: 10, // Margin for the element
                                        cols: [
                                            // Column layout
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Orden'), // Label with localization
                                                name: 'Order', // Input name
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Orden Destacado'), // Label with localization
                                                name: 'FeaturedOrder', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Filas'), // Label with localization
                                                name: 'Rows', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                            {
                                                view: 'text', // Text input
                                                labelPosition: 'top', // Label position
                                                label: _('Columnas'), // Label with localization
                                                name: 'Columns', // Input name
                                                labelWidth: 160, // Label width
                                                attributes: { type: 'number' }, // Input type
                                            },
                                        ],
                                    },
                                    {
                                        view: 'forminput', // Double list input for partners
                                        body: {
                                            view: 'dbllist', // Double list component
                                            id: 'dblPartnersAdd', // ID for the double list
                                            list: { height: 200, scroll: true }, // List configuration
                                            labelLeft: _('Partners'), // Left label
                                            labelRight: _('Partners Seleccionados'), // Right label
                                            data: profile.Partners, // Data source for partners
                                        },
                                        labelWidth: 140, // Label width
                                        labelAlign: 'right', // Label alignment
                                    },
                                    {
                                        view: 'forminput', // Double list input for categories
                                        body: {
                                            view: 'dbllist', // Double list component
                                            id: 'dbllistAdd', // ID for the double list
                                            list: { height: 200, scroll: true }, // List configuration
                                            labelLeft: _('Categorías'), // Left label
                                            labelRight: _('Categorías Producto Partner'), // Right label
                                            data: optionsCategorias, // Data source for categories
                                        },
                                        labelWidth: 140, // Label width
                                        labelAlign: 'right', // Label alignment
                                    },
                                    {
                                        cols: [
                                            // Column layout for buttons
                                            {
                                                view: 'button', // Cancel button
                                                value: _('Cancelar'), // Button text with localization
                                                click: function () {
                                                    // Click event for cancel button
                                                    this.getTopParentView().hide(); // Hide the popup
                                                    $$('addform').clear(); // Clear the add form
                                                },
                                            },
                                            {
                                                view: 'button', // Save button
                                                type: 'form', // Button type
                                                value: _('Guardar'), // Button text with localization
                                                click: function ($e) {
                                                    // Click event for save button
                                                    var values = $$(
                                                        // Get values from the form
                                                        'addform',
                                                    ).getValues();
                                                    var c2this = this; // Reference to the current instance
                                                    values.Partners = arrayPartnersAdd; // Set partners
                                                    arrayPartnersWithoutAdd = []; // Reset array for partners not added
                                                    for (
                                                        // Loop through profile partners
                                                        var i = 0;
                                                        i < profile.Partners.length;
                                                        i++
                                                    ) {
                                                        var flagPartners = false; // Flag for partner existence
                                                        for (
                                                            // Check if partner is in added array
                                                            var j = 0;
                                                            (j < arrayPartnersAdd.length) & !flagPartners;
                                                            j++
                                                        ) {
                                                            if (profile.Partners[i].id == arrayPartnersAdd[j])
                                                                flagPartners = true; // Set flag if found
                                                        }
                                                        if (!flagPartners)
                                                            // If not found, add to the array
                                                            arrayPartnersWithoutAdd.push(profile.Partners[i].id);
                                                    }
                                                    values.PartnersWithoutAdd = arrayPartnersWithoutAdd; // Set partners not added
                                                    values.CategoriesAdd = arrayAdd; // Set categories added
                                                    arrayWithoutAdd = []; // Reset array for categories not added
                                                    for (
                                                        // Loop through category options
                                                        var i = 0;
                                                        i < optionsCategorias.length;
                                                        i++
                                                    ) {
                                                        var flag = false; // Flag for category existence
                                                        for (
                                                            // Check if category is in added array
                                                            var j = 0;
                                                            (j < arrayAdd.length) & !flag;
                                                            j++
                                                        ) {
                                                            if (optionsCategorias[i].Id == arrayAdd[j]) flag = true; // Set flag if found
                                                        }
                                                        if (!flag)
                                                            // If not found, add to the array
                                                            arrayWithoutAdd.push(optionsCategorias[i].Id);
                                                    }
                                                    values.CategoriesWithoutAdd = arrayWithoutAdd; // Set categories not added
                                                    // AJAX request to create partner product
                                                    webix
                                                        .ajax()
                                                        .headers({
                                                            'Content-type': 'application/json', // Set content type
                                                        })
                                                        .post(
                                                            devConfig.geturlApi() +
                                                                'PartnerProduct/CreatePartnerProduct',
                                                            values, // Send form values
                                                            {
                                                                error: function (text, data, XmlHttpRequest) {
                                                                    // Error handler
                                                                    webix.message('Error! '); // Show error message
                                                                },
                                                                success: function (text, data, XmlHttpRequest) {
                                                                    // Success handler
                                                                    text = JSON.parse(text); // Parse response
                                                                    if (text.HasError) {
                                                                        // Check for errors
                                                                        webix.message('Error: ' + text.AlertMessage); // Show error message
                                                                    } else {
                                                                        $$('addform').clear(); // Clear the add form
                                                                        c2this.getTopParentView().hide(); // Hide the popup
                                                                        webix.message('Producto Partner Agregado'); // Show success message
                                                                    }
                                                                },
                                                            },
                                                        );
                                                },
                                            },
                                        ],
                                    },
                                ],
                            },
                        },
                    });
                    $$('dbllistAdd').attachEvent(
                        // Attach event for category add double list
                        'onChange',
                        function (id, e, node) {
                            if ($$('dbllistAdd').getValue() != '') {
                                // Check if value is not empty
                                arrayAdd = $$('dbllistAdd').getValue().split(','); // Set added categories
                            } else {
                                arrayAdd = []; // Reset added categories
                            }
                        },
                    );
                    $$('dblPartnersAdd').attachEvent(
                        // Attach event for partner add double list
                        'onChange',
                        function (id, e, node) {
                            if ($$('dblPartnersAdd').getValue() != '') {
                                // Check if value is not empty
                                arrayPartnersAdd = $$('dblPartnersAdd').getValue().split(','); // Set added partners
                            } else {
                                arrayPartnersAdd = []; // Reset added partners
                            }
                        },
                    );
                },
            });
        this.on(this.app, 'changePartnetsEdit', (filter) => {
            // Event for partner edit change
            if ($$('dblPartnersEdit').getValue() != '') {
                // Check if value is not empty
                arrayPartnersEdit = $$('dblPartnersEdit').getValue().split(','); // Set edited partners
            } else {
                arrayPartnersEdit = []; // Reset edited partners
            }
        });
        this.on(this.app, 'changeCategoriesEdit', (filter) => {
            // Event for category edit change
            if ($$('dbllistEdit').getValue() != '') {
                // Check if value is not empty
                arrayAddEdit = $$('dbllistEdit').getValue().split(','); // Set edited categories
            } else {
                arrayAddEdit = []; // Reset edited categories
            }
        });
        this.on(this.app, 'addProductPartner:button', (filter) => {
            // Event for adding partner product
            if (optionsCategorias.length > 0 && products.length > 0) {
                // Check if categories and products are available
                $$('addform').clearValidation(); // Clear validation
                popupAdd.show(); // Show the add popup
                var optionsCountries = $$('AddProduct').getList(); // Get options for countries
                optionsCountries.clearAll(); // Clear existing options
                optionsCountries.parse(products); // Parse products into the list
            } else {
                webix.message({
                    // Show error message
                    text: _('Datos no han podido ser cargados'), // Error message with localization
                    title: _('¡Error!'), // Title for the error message
                    type: 'alert-error', // Error message type
                });
            }
        });
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            // Event for filtering partner products
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Loop through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check if value is not an object and not empty
                    if (object[i][0] == 'Datepicker') {
                        // Check for datepicker
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Check if value is an object
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Loop through object entries
                            if (object2[j][1] !== null) {
                                // Check if value is not null
                                if (object2[j][0] === 'start') {
                                    // Check for start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom = // Format start date
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Check for end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo = // Format end date
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data into the grid
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger event with item ID
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event for player selection
            grid.load(
                // Load grid data based on selected player
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event for item double click
            var item = this.getItem(id); // Get the double-clicked item
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event after sorting
            grid.load(
                // Load sorted data into the grid
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir,
            );
        });
        // AJAX request to fetch products for the report
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Report/GetProducts', '', {
                error: function (text, data, XmlHttpRequest) {
                    // Error handler
                    webix.message('Error! '); // Show error message
                },
                success: function (text, data, XmlHttpRequest) {
                    // Success handler
                    var data = JSON.parse(
                        // Parse response
                        text
                            .replace(/"Id"/g, '"id"') // Replace Id with id
                            .replace(/"Name"/g, '"value"'), // Replace Name with value
                    );
                    console.log(data); // Log the data
                    products = data.Data; // Set products data
                },
            });
    }
}

// FILE DOCUMENTED
